import { Fancybox } from "@fancyapps/ui";
var ViewDocument = /** @class */ (function () {
    function ViewDocument() {
        this.documentPage = document.querySelector('.documents-page');
        this.viewDocumentButtons = Array.from(this.documentPage.querySelectorAll('[data-view-document]'));
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.addEventListeners();
    }
    ViewDocument.prototype.addEventListeners = function () {
        var _this = this;
        this.viewDocumentButtons.forEach(function (viewDocumentButton) {
            viewDocumentButton.addEventListener('click', _this.viewDocument.bind(_this));
        });
    };
    ViewDocument.prototype.viewDocument = function (event) {
        var _this = this;
        var currentTarget = event.currentTarget;
        var documentSrc = currentTarget.dataset.viewDocument;
        if (documentSrc) {
            // Check if document source is set
            this.body.classList.add('no-scroll');
            this.pageOverlay.classList.add('visible');
            this.pageLoader.classList.add('active');
            var fancybox = new Fancybox([
                {
                    src: documentSrc,
                    // @ts-ignore
                    type: "pdf"
                },
            ]);
            fancybox.on('done', function (fancybox) {
                _this.body.classList.remove('no-scroll');
                _this.pageOverlay.classList.remove('visible');
                _this.pageLoader.classList.remove('active');
            });
        }
    };
    return ViewDocument;
}());
export default ViewDocument;
